import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { observer } from "mobx-react";
import styled from "styled-components";
import Box from "@material-ui/core/Box";
import { Tooltip} from "@material-ui/core";
import ShareRecord from './ShareRecord';

class TriggerColumnRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActionExecuting: 0,
      isDeletingRow: false,
      isShareDialogOpen: false,
    };
    this.getActionButton = this.getActionButton.bind(this);
    this.handleShareClose = this.handleShareClose.bind(this);
  }

  getActionButton(isEnabled, action, event, index, onClick) {
    if (!isEnabled && action == "hide") {
      return null;
    }
    var isButtonDisabled, isLoading;
    isButtonDisabled = isLoading = this.props.store?.executingEvents[
      this.props.data.row_id
    ]?.includes(event.id)
      ? true
      : false;
    if (!isEnabled && action == "disable") {
      isButtonDisabled = true;
    }
    let query = "";

    if (isButtonDisabled && typeof event.criteria == "string") {
      query = this.props.store.parseQueryForTooltip(event);
    }
    return (
      <Tooltip
        title={
          isButtonDisabled
            ? `This action is disabled due to this condition : ${query}`
            : ""
        }
      >
        <ButtonWrappperDiv>
          <StyledButton
            key={index}
            size="small"
            className="muiTrigger margin-2"
            variant="outlined"
            onClick={onClick}
            disabled={isButtonDisabled}
            isActionButton={true}
          >
            <StyledButtonTextDiv
              disabled={isButtonDisabled}
              className={isButtonDisabled ? "" : "triggerBtnForTooltip"}
            >
              {event.label}
            </StyledButtonTextDiv>
            {isLoading && <CircularProgress size={18} color="inherit" />}
          </StyledButton>
        </ButtonWrappperDiv>
      </Tooltip>
    );
  }


  handleShareClose() {
    this.props.closeTriggerColumnPopper();
    this.setState({ isShareDialogOpen: false });
  }

  render() {
    const OuterDiv = this.props.actionButtonsCount >= 9 ? StyledDiv : "div";
    return (
      <OuterDiv className="d-flex flex-column">
        {this.props.store.containerStore?.permissions?.canEdit()[0] && (
          <StyledButton
            size="small"
            className="muiTrigger"
            variant="outlined"
            onClick={() => {
              this.props.closeTriggerColumnPopper();
              this.props.store.containerStore?.showForm(
                "Edit",
                this.props.data.row_id
              );
            }}
          >
            <Box m={1}>Edit</Box>
          </StyledButton>
        )}
        {this.props.store.containerStore?.permissions?.canAdd() && (
          <StyledButton
            size="small"
            className="muiTrigger"
            variant="outlined"
            onClick={() => {
              this.props.closeTriggerColumnPopper();
              this.props.store.containerStore?.showForm(
                "New",
                "",
                this.props.data.row_id
              );
            }}
          >
            <Box m={1}>Duplicate</Box>
          </StyledButton>
        )}
        {this.props.store.containerStore?.permissions?.canDelete() && (
          <StyledButton
            size="small"
            className="muiTrigger"
            variant="outlined"
            disabled={this.state.isDeletingRow}
            onClick={async () => {
              try {
                await window.appStore.notificationStore.confirm({
                  description: <>This will delete the selected row</>,
                });
                this.setState({ isDeletingRow: true });
                await this.props.store.bulkDeleteAction(this.props.data.row_id);
                this.setState({ isDeletingRow: false });
                this.props.closeTriggerColumnPopper();
                await this.props.store.refreshData();
              } catch (e) {}
            }}
          >
            <Box m={1}>Delete</Box>
            {this.state.isDeletingRow && (
              <CircularProgress size={18} color="inherit" />
            )}
          </StyledButton>
        )}
        <StyledButton
          size="small"
          className="muiTrigger"
          variant="outlined"
          onClick={() => {
            this.props.closeTriggerColumnPopper();
            this.props.store.containerStore?.handlePrint(
              this.props.data.row_id
            );
          }}
        >
          <Box m={1}>Print</Box>
        </StyledButton>

        {!this.props.store?.isSubsheet && (<StyledButton
          size="small"
          className="muiTrigger"
          variant="outlined"
          onClick={() => {
            this.setState({ isShareDialogOpen: true });
          }}
        >
          <Box m={1}>Share</Box>
        </StyledButton>)}
          {this.state.isShareDialogOpen && (
          <ShareRecord
            isOpen={this.state.isShareDialogOpen}
            onClose={this.handleShareClose}
            rowId={this.props.data.row_id}
            listId={this.props.store.listId}
            listConfig={this.props.store.listConfig}
          />
        )}
        {this.props.store.userEvents.length > 0 && <Separator></Separator>}
        {this.props.store.userEvents.map(
          (event, index) =>
            event.position.split(",").includes("menu") &&
            this.getActionButton(
              this?.props?.data?.["is_event_" + event.id + "_disabled"] === "0",
              event.criteria_action,
              event,
              index,
              async () => {
                try {
                  await window.appStore.notificationStore.confirm({
                    title: <>Confirmation</>,
                    description: (
                      <>
                        Are you sure you want to perform this action {event.name}
                      </>
                    ),
                  });
                  if (
                    this.props.data.row_id in this.props.store.executingEvents
                  ) {
                    this.props.store.executingEvents[this.props.data.row_id].push(
                      event.id
                    );
                  } else {
                    this.props.store.executingEvents[this.props.data.row_id] = [];
                    this.props.store.executingEvents[this.props.data.row_id].push(
                      event.id
                    );
                  }
                  await this.props.store.executeAction(
                    this.props.data.row_id,
                    this.props.data.uniqueId,
                    event.id
                  );
                  this.props.store.executingEvents[this.props.data.row_id].splice(
                    this.props.store.executingEvents[
                      this.props.data.row_id
                    ].indexOf(event.id),
                    1
                  );
                  if (
                    this.props.store.executingEvents[this.props.data.row_id]
                      .length == 0
                  ) {
                    delete this.props.store.executingEvents[
                      this.props.data.row_id
                    ];
                  }
                } catch (e) {
                  console.log(e);
                }
              })
          )}
        </OuterDiv>
    );
  }
}

export default observer(TriggerColumnRenderer);

const StyledButton = styled(Button)`
  text-transform: uppercase !important;
  background-color: white;
  &:hover {
    background-color: #f6f1f1;
  }
  width: 92%;
  margin: ${props => (props.isActionButton ? "2px 2px 2px 4px !important" : "2px 2px 2px 2px !important")};
  border : ${props => (props.disabled ? "1px solid rgba(0, 0, 0, 0.20)" : "1px solid rgba(0, 0, 0, 0.30)")};
`;

const StyledDiv = styled.div`
  max-height: 350px;
  overflow: scroll;
`;

const Separator = styled.div`
  border-bottom: 1px solid #cccccc;
  margin: 6px 0px;
`;

const StyledButtonTextDiv = styled.div`
  width:100%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  color : ${props => (props.disabled ? "rgba(0, 0, 0, 0.20)" : "black")};
`;

const ButtonWrappperDiv = styled.div`
  line-height: 0rem;
`;
